import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=1edff9e2&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=1edff9e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edff9e2",
  null
  
)

export default component.exports